<template>
  <div
    class="quiz-block"
    :style="{
      backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
      paddingBottom: '0px',
      borderRadius: '12px',
      cursor: 'default'
    }"
    style=" margin-bottom: 15px !important;"
  >
    <!-- IMAGE -->
    <div class="quiz-image">
      <img
        :class="[quiz_data.is_live ? '' : 'brightness']"
        :src="quiz_data.banner_url"
        alt="quiz"
        class="img-fluid"
        style="border-radius: 0"
      />
    </div>

    <!-- CONTENT AREA -->
    <div
      style="display: flex; justify-content: space-between; align-items: center;"
    >
      <!-- LEFT -->
      <div>
        <p
          :style="{
            margin: '-20px 0px 5px 0px',
            fontSize: '16px',
            color: '#000000',
            fontWeight: '500'
          }"
        >
          {{ quiz_data.name }}
        </p>

        <p style="font-size: 12px; margin: 0; color: gray;">
          Win up to:
          <img
            :src="quiz_data.currency_icon_url"
            style="width: 10px; height: 10px; margin: 0 3px 0 2px;"
          />
          {{ quiz_data.max_reward }}
        </p>
      </div>

      <!-- RIGHT -->
      <div
        style="display: flex; justify-content: center; align-items: center; flex-direction: column; padding-top: 5px;"
      >
        <!-- TIMER -->
        <div
          style="font-size: 10px; font-weight: 600;"
          :class="[active ? 'quiz-end' : '', 'timer']"
        >
          <span>{{
            active ? "Ends In:- " + time_left : "Starts In:- " + time_left
          }}</span>
        </div>

        <!-- PLAY BUTTON -->
        <div style="padding-bottom: 8px;">
          <!-- ACTIVE — CLICKABLE -->
          <router-link
            v-if="active"
            :to="{
              name: 'survey_details_custom',
              params: { id: quiz_data.id, title: quiz_data.name }
            }"
            style="text-decoration:none;"
          >
            <span
              :style="{
                backgroundColor: isDarkTheme ? buttonBGColor : bgTheme,
                padding: '8px',
                borderRadius: '20px',
                color: isDarkTheme ? headingTextColor : '#fff',
                fontSize: '12px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '5px',
                width: '100%'
              }"
            >
              {{ quiz_data.is_live ? "Play" : button_text || "Play" }}
              <PlayIcon />
            </span>
          </router-link>

          <!-- INACTIVE — NOT CLICKABLE -->
          <span
            v-else
            :style="{
              backgroundColor: '#cccccc',
              padding: '8px',
              borderRadius: '20px',
              color: isDarkTheme ? headingTextColor : '#ffffff',
              fontSize: '12px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '5px',
              width: '100%'
            }"
          >
            {{ button_text || "Play" }}
            <PlayIcon />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { asset } from "@/utils/asset";
import moment from "moment";
import { globals } from "@/mixins/globals";
import { width } from "@fortawesome/free-regular-svg-icons/faAddressBook";
import PlayIcon from "./play-icon.vue";
export default {
  name: "survey-list-card",
  mixins: [globals],
  props: {
    quiz_data: Object
  },
  components: {
    PlayIcon
  },
  data() {
    return {
      time_left: "",
      active: false,
      dateStr: this.active ? this.quiz_data.ends_at : this.quiz_data.starts_at,
      quiz: this.quiz_data,
      button_text: this.quiz_data.button_text
    };
  },
  methods: {
    formatISODateString(dateStr) {
      var date = new Date(dateStr);
      var month = date.toLocaleString("default", { month: "short" });
      var year = date.getFullYear();
      var hour = date.getHours();
      var min = date.getMinutes();
      var sec = date.getSeconds();
      var dt = date.getDate();

      if (dt < 10) {
        dt = "0" + dt;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (min < 10) {
        min = "0" + min;
      }
      if (sec < 10) {
        sec = "0" + sec;
      }

      // return `${dt} ${month} ${year} ${hour}:${min}:${sec}`;
      return `${hour}h:${min}m:${sec}s`;
    },
    getImgUrl(pic) {
      return asset(pic);
    },
    async showTime(data) {
      let dateStr = "";
      let timeleft = "";
      if (data.is_live || this.active) {
        dateStr = data.ends_at;
      } else {
        dateStr = data.starts_at;
      }
      var d = new Date();
      var d2 = new Date(dateStr);
      var milSec = d2 - d;
      while (milSec > 0) {
        var d3 = new Date(milSec);
        let nrDays = Math.floor(d3 / 1000 / 60 / 60 / 24);
        let nrHours = Math.floor(d3 / 1000 / 60 / 60) % 24;
        let nrMin = Math.floor(d3 / 1000 / 60) % 60;
        let nrSec = Math.floor(d3 / 1000) % 60;

        nrHours = nrHours < 10 ? "0" + nrHours : nrHours;
        nrMin = nrMin < 10 ? "0" + nrMin : nrMin;
        nrSec = nrSec < 10 ? "0" + nrSec : nrSec;
        if (nrDays !== 0) {
          nrDays = nrDays < 10 ? "0" + nrDays + "d:" : nrDays + "d:";
        } else {
          nrDays = "";
        }
        timeleft = `${nrDays}${nrHours}h:${nrMin}m:${nrSec}s`;
        timeleft.replace("-", "");
        milSec -= 1000;
        this.time_left = timeleft;
        await this.sleep(1000);
      }
      if (new Date(data.ends_at) < new Date()) {
        // alert('hi')
        this.$emit("quizend");
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  },
  created() {
    this.button_text = this.quiz_data.button_text;
    this.showTime(this.quiz);
    this.active = Date(this.quiz) > Date();
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    isDescriptionColour() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDescriptionColour
      ) {
        return this.$store.state.sdkEvent.isDescriptionColour;
      }
      return null;
    },
    time: () => {
      return this.time_left;
    }
  },
  mounted: function() {
    setInterval(() => {
      //this.date = moment(this.date.subtract(1, 'seconds'))
    }, 1000);
    this.interval = setInterval(
      () => (this.active = new Date(this.quiz.starts_at) < new Date())
    );
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  watch: {
    active(val) {
      if (val) {
        this.quiz_data.is_live = true;
        this.showTime(this.quiz);
      }
    }
  }
};
</script>
<style scoped>
@import "../assets/quiz-styles/quiz-styles.css";

.brightness {
  filter: brightness(0.75);
  opacity: 0.65;
}
.quiz-play {
  display: flex;
  justify-content: center;
  padding: 0.25rem;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}
.h3 {
  color: #736c6c;
  font-size: 20px;
  margin-block-start: 0 !important;
  margin-block-end: 0 !important;
}
.total-prize {
  margin-top: 5px;
  color: #736c6c;
  font-size: 13px;
  font-weight: lighter;
}

.play-time-details {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 3rem;
  background-color: aqua;
}
</style>
